module.exports = __webpack_public_path__ + "static/img/4.6516d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/4.png
// module id = L2tg
// module chunks = 1